/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { WalletId } from "./WalletId";
import { WalletStatus } from "./WalletStatus";
import { WalletApplicationInfo } from "./WalletApplicationInfo";
import { WalletInfoDetails } from "./WalletInfoDetails";
import * as t from "io-ts";
import { WalletClient } from "./WalletClient";
import { UTCISODateFromString } from "@pagopa/ts-commons/lib/dates";

/**
 * Wallet information
 */

/**
 * Client-specific state (e.g. last usage) and configuration (enabled/disabled)
 */

// additional attributes

export const WalletInfoClients = t.record(
  t.string,

  WalletClient,

  "WalletInfoClients"
);

export type WalletInfoClients = t.TypeOf<typeof WalletInfoClients>;

// required attributes
const WalletInfoR = t.interface({
  walletId: WalletId,

  paymentMethodId: t.string,

  status: WalletStatus,

  creationDate: UTCISODateFromString,

  updateDate: UTCISODateFromString,

  applications: t.readonlyArray(
    WalletApplicationInfo,
    "array of WalletApplicationInfo"
  ),

  clients: WalletInfoClients,

  paymentMethodAsset: t.string
});

// optional attributes
const WalletInfoO = t.partial({
  details: WalletInfoDetails
});

export const WalletInfo = t.intersection(
  [WalletInfoR, WalletInfoO],
  "WalletInfo"
);

export type WalletInfo = t.TypeOf<typeof WalletInfo>;
